import * as GeneralTypes from "../types/General"

const initialState = {
  isLoadingAllItems: false,
  isLoadingIndex: false,
  isLoadingDailyData: false,
  allItems: [],
  activeIndex: {},
  dailyData: []
}

export default function data(state = initialState, action) {
  switch (action.type) {
    case GeneralTypes.LOAD_ALL_ITEMS_START: {
      return {
        ...state,
        isLoadingAllItems: false
      }
    }
    case GeneralTypes.LOAD_ALL_ITEMS_SUCCESS: {
      return {
        ...state,
        allItems: action.payload,
        isLoadingAllItems: true
      }
    }
    case GeneralTypes.LOAD_ALL_ITEMS_FAILED: {
      return {
        ...state,
        isLoadingAllItems: false
      }
    }
    case GeneralTypes.LOAD_INDEX_CLEAR: {
      return {
        ...state,
        activeIndex: {},
        isLoadingIndex: false
      }
    }
    case GeneralTypes.LOAD_INDEX_START: {
      return {
        ...state,
        isLoadingIndex: false
      }
    }
    case GeneralTypes.LOAD_INDEX_SUCCESS: {
      return {
        ...state,
        activeIndex: [action.payload],
        isLoadingIndex: true
      }
    }
    case GeneralTypes.LOAD_INDEX_FAILED: {
      return {
        ...state,
        isLoadingIndex: false
      }
    }
    case GeneralTypes.LOAD_DAILY_DATA_START: {
      return {
        ...state,
        isLoadingDailyData: false
      }
    }
    case GeneralTypes.LOAD_DAILY_DATA_SUCCESS: {
      return {
        ...state,
        dailyData: action.payload,
        isLoadingDailyData: true
      }
    }
    case GeneralTypes.LOAD_DAILY_DATA_FAILED: {
      return {
        ...state,
        isLoadingDailyData: false
      }
    }
    case GeneralTypes.LOAD_DAILY_DATA_CLEAR: {
      return {
        ...state,
        dailyData: []
      }
    }

    default:
      return state
  }
}